export const defaultLimitPagination = 10
export const fiftyLimitPagination = 50
